import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ZenitAnalyticsState } from '../zenit.state';

export const getZenitState = createFeatureSelector<ZenitAnalyticsState>('zenit');

export const getZenitOriginItemEventFrom = createSelector(getZenitState, (state) => state.originItemEventFrom);

export const getZenitOriginItemListIndex = createSelector(getZenitState, (state) => state.originItemListIndex);

export const getZenitOriginItemListName = createSelector(getZenitState, (state) => state.originItemListName);

export const getZenitOriginItemRelatedType = createSelector(getZenitState, (state) => state.originItemRelatedType);
